<script setup lang="ts">
import { useMaskedValue } from "@/composables/useMaskedValue"
import { formatCnpj, normalizeCnpj } from "@/lib/masks"
import UiFieldWrapper from "./UiFieldWrapper.vue"

const model = defineModel<string>({ default: "" })

withDefaults(
  defineProps<{
    id: string
    label?: string
    placeholder?: string
    required?: boolean
    disabled?: boolean
    error?: string
    helperText?: string
  }>(),
  {
    label: "CNPJ",
    placeholder: "00.000.000/0000-00",
    required: false,
    disabled: false,
    error: "",
    helperText: "",
  }
)

const { displayValue, handleInput } = useMaskedValue(
  () => model.value,
  (_event, value) => {
    model.value = value
  },
  formatCnpj,
  normalizeCnpj
)
</script>

<template>
  <UiFieldWrapper :label="label" :for-id="id" :error="error" :helper-text="helperText">
    <input
      :id="id"
      :value="displayValue"
      :placeholder="placeholder"
      :required="required"
      :disabled="disabled"
      inputmode="numeric"
      class="w-full rounded-md border border-slate-300 px-3 py-2 text-sm text-slate-900 transition placeholder:text-slate-400 focus:border-slate-400 focus:outline-none"
      @input="handleInput"
    />
  </UiFieldWrapper>
</template>

